import { useState } from 'react';
import Avatar from 'boring-avatars';

import { useAuthStore } from '@stores/auth-store';

import styles from './header.module.scss';

interface Props {
    mode?: string;
    title: string;
    subtitle?: string;
}

const Header = (props: Props) => {
    const { user, role } = useAuthStore();

    const [name] = useState(user?.firstName.split(' ')?.[0]);

    return (
        <header className={styles.header}>
            <div className={styles.welcome}>
                <h1>{props.title}</h1>
                {props.subtitle && <h3>{props.subtitle}</h3>}
            </div>
            <div
                className={'flex align-center'}
                style={{ gap: 10, marginLeft: 20 }}
            >
                {/*<Notifications iconColor={'#565454'} />*/}
                <div className={styles.userData}>
                    <span>{name}</span>
                    <span className={styles.role}>{role?.name}</span>
                </div>
                <Avatar size={40} />
            </div>
        </header>
    );
};

export default Header;
